import React, { memo } from "react";
import RouterConfig from "../../router";

export default memo(function HomeLayoutComponent() {
   return <RouterConfig/>
});
